import { __extends } from "tslib";
import { DescribeEntityRecognizerRequest, DescribeEntityRecognizerResponse } from "../models/index";
import { deserializeAws_json1_1DescribeEntityRecognizerCommand, serializeAws_json1_1DescribeEntityRecognizerCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DescribeEntityRecognizerCommand = /** @class */ (function (_super) {
    __extends(DescribeEntityRecognizerCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeEntityRecognizerCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DescribeEntityRecognizerCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: DescribeEntityRecognizerRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DescribeEntityRecognizerResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeEntityRecognizerCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1DescribeEntityRecognizerCommand(input, context);
    };
    DescribeEntityRecognizerCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1DescribeEntityRecognizerCommand(output, context);
    };
    return DescribeEntityRecognizerCommand;
}($Command));
export { DescribeEntityRecognizerCommand };
//# sourceMappingURL=DescribeEntityRecognizerCommand.js.map